import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import Innenarbeiten from "./pages/Innenarbeiten";
import InnendaemmungSchimmelschutzHerford from "./pages/dienstleistung/InnendaemmungSchimmelschutzHerford";
import Innendaemmung from "./pages/dienstleistung/Innendaemmung";
import Fassadensanierung from "./pages/dienstleistung/Fassadensanierung";
import FassadensanierungWDVS from "./pages/dienstleistung/FassadensanierungWDVS";
import Badsanierung from "./pages/dienstleistung/Badsanierung";
import BadrenovierungHerford from "./pages/dienstleistung/BadrenovierungHerford";
import EnergetischeSanierungHerford from "./pages/dienstleistung/EnergetischeSanierungHerford";
import Malerarbeiten from "./pages/dienstleistung/Malerarbeiten";
import InnensanierungMalerarbeitenHerford from "./pages/dienstleistung/InnensanierungMalerarbeitenHerford";
import EdleOberflaechenHerford from "./pages/dienstleistung/EdleOberflaechenHerford";
import AngebotFassade from "./pages/AngebotFassade";
import Standort from "./pages/Standort";

import Kontakt from "./pages/Kontakt";
import UeberUns from "./pages/UeberUns";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/fassadensanierung-herford" element={<Fassadensanierung />} />
          <Route path="/fassadensanierung-wdvs-herford" element={<FassadensanierungWDVS />} />
          <Route path="/innendaemmung-schimmelschutz" element={<Innendaemmung />} />
          <Route path="/innendaemmung-schimmelschutz-herford" element={<InnendaemmungSchimmelschutzHerford />} />
          <Route path="/innensanierung-herford" element={<Innenarbeiten />} />
          <Route path="/malerarbeiten-innenraum" element={<Malerarbeiten />} />
          <Route path="/fugenlose-baeder-oberflaechen" element={<Badsanierung />} />
          <Route path="/energetische-sanierung-herford" element={<EnergetischeSanierungHerford />} />
          <Route path="/innensanierung-malerarbeiten-herford" element={<InnensanierungMalerarbeitenHerford />} />
          <Route path="/badrenovierung-fugenlose-baeder-herford" element={<BadrenovierungHerford />} />
          <Route path="/edle-oberflaechen-designboeden-herford" element={<EdleOberflaechenHerford />} />
          <Route path="/maler-:slug" element={<Standort />} />
          <Route path="/maler/:slug" element={<Standort />} />

          <Route path="/angebot-fassadensanierung" element={<AngebotFassade />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/ueber-uns" element={<UeberUns />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;

